import script from "./NamespaceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NamespaceModal.vue?vue&type=script&setup=true&lang=ts"

import "./NamespaceModal.vue?vue&type=style&index=0&id=ba0d26bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0d26bc"]])

export default __exports__